import React, { useEffect, useRef, useState } from 'react';
import { BsFillBellFill, BsFillEnvelopeFill, BsJustify, BsPersonCircle, BsSearch } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';
import './Header.css';
import { useAdminAuth } from '../../AdminAuthContext';

function Header({ OpenSidebar }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const { adminLogout } = useAdminAuth();

  const handleProfileClick = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleProfileNavigate = () => {
    navigate('/profile');
    setDropdownOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <header className='headerr'>
      <div className='menu-icon'>
        <BsJustify className='icon' onClick={OpenSidebar} />
      </div>
      <div className='header-left'>
        {/* <BsSearch className='icon' /> */}
      </div>
      <div className='header-right'>
        <div className='profile-dropdown' ref={dropdownRef}>
          <BsPersonCircle className='icon' onClick={handleProfileClick} />
          {dropdownOpen && (
            <div className='dropdown-menu'>
              {/* <button onClick={handleProfileNavigate}>Go to Profile</button> */}
              <button onClick={adminLogout}>Logout</button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;
